export const pricingTiers = [
  {
    name: 'Strategy Session',
    price: '$350',
    cadence: 'one-time',
    summary: 'Business Performance Review',
    features: [
      '90-minute executive session',
      'P&L and KPI review',
      'Top three margin opportunities',
      'Written action summary',
    ],
    cta: 'Book a Session',
    recommended: false,
  },
  {
    name: 'ROI Complete Consulting',
    price: 'Custom',
    cadence: 'monthly plans',
    summary: 'Hands-on operational partnership',
    features: [
      'Operational assessment & audit',
      'SOP development',
      'Cost control implementation',
      'Executive coaching cadence',
      'Quarterly growth planning',
    ],
    cta: 'Request a Plan',
    recommended: true,
  },
  {
    name: 'ROI Complete Software',
    price: 'Custom',
    cadence: 'monthly subscription',
    summary: 'Real-time operational intelligence',
    features: [
      'Dashboards & reporting',
      'Inventory and food cost',
      'Labor and KPI tracking',
      'Mobile app access',
      'AI insights',
    ],
    cta: 'Start a Trial',
    recommended: false,
  },
  {
    name: 'Enterprise Solutions',
    price: 'Custom Quote',
    cadence: 'tailored agreement',
    summary: 'Multi-location and franchise scale',
    features: [
      'Multi-location reporting',
      'Franchise standards rollout',
      'Dedicated account team',
      'Custom integrations',
      'Onsite leadership training',
    ],
    cta: 'Contact Us',
    recommended: false,
  },
]
